import { useState, useCallback } from 'react';
import type { SnackbarSeverity, SnackbarState } from '../types/admin';

export interface UseSnackbarReturn {
  snackbar: SnackbarState;
  showSnackbar: (message: string, severity: SnackbarSeverity) => void;
  handleClose: () => void;
}

/**
 * スナックバー状態管理のカスタムフック
 * 
 * @example
 * const { snackbar, showSnackbar, handleClose } = useSnackbar();
 * 
 * // 成功メッセージを表示
 * showSnackbar('保存しました', 'success');
 * 
 * // エラーメッセージを表示
 * showSnackbar('エラーが発生しました', 'error');
 */
export const useSnackbar = (): UseSnackbarReturn => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'info',
  });

  const showSnackbar = useCallback((message: string, severity: SnackbarSeverity) => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleClose = useCallback(() => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);

  return { snackbar, showSnackbar, handleClose };
};

